import React, { useState } from 'react';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { ServiceDetailsPage } from './pages/ServiceDetailsPage';
import { AboutUsPage } from './pages/AboutUsPage';
import { OurServicePage } from './pages/OurServicePage';
import { FAQPage } from './pages/FAQPage';
import { ContactUsPage } from './pages/ContactUsPage';
import { CancellationPolicyPage } from './pages/CancellationPolicyPage';
import { RefundPolicyPage } from './pages/RefundPolicyPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsConditionsPage } from './pages/TermsConditionsPage';
export type Page = 'home' | 'service-details' | 'about-us' | 'our-service' | 'faq' | 'contact-us' | 'cancellation-policy' | 'refund-policy' | 'privacy-policy' | 'terms-conditions';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage data-id="element-0" />;
      case 'service-details':
        return <ServiceDetailsPage data-id="element-1" />;
      case 'about-us':
        return <AboutUsPage data-id="element-2" />;
      case 'our-service':
        return <OurServicePage data-id="element-3" />;
      case 'faq':
        return <FAQPage data-id="element-4" />;
      case 'contact-us':
        return <ContactUsPage data-id="element-5" />;
      case 'cancellation-policy':
        return <CancellationPolicyPage data-id="element-6" />;
      case 'refund-policy':
        return <RefundPolicyPage data-id="element-7" />;
      case 'privacy-policy':
        return <PrivacyPolicyPage data-id="element-8" />;
      case 'terms-conditions':
        return <TermsConditionsPage data-id="element-9" />;
      default:
        return <HomePage data-id="element-10" />;
    }
  };
  return <div className="min-h-screen flex flex-col font-sans text-slate-900 bg-background" data-id="element-11">
      <Header currentPage={currentPage} onNavigate={setCurrentPage} data-id="element-12" />
      {renderPage()}
      <Footer onNavigate={setCurrentPage} data-id="element-13" />
    </div>;
}